var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _c("router-view", {
        staticStyle: { "min-height": "calc(100vh - 14rem)" }
      }),
      _vm._v(" "),
      _c("partners-list"),
      _vm._v(" "),
      _c("footer", { staticClass: "my-5" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "content has-text-centered" }, [
            _c("p", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("footer_copyrights", {
                    year: new Date().getFullYear()
                  })
                )
              }
            }),
            _vm._v(" "),
            _c("p", { staticClass: "is-size-7" }, [
              _c(
                "a",
                {
                  attrs: { href: _vm.$t("public_site_uri"), target: "_blank" }
                },
                [_vm._v(_vm._s(_vm.$t("public_site_label")))]
              ),
              _vm._v(" · "),
              _c(
                "a",
                { attrs: { href: _vm.$t("terms_uri"), target: "_blank" } },
                [_vm._v(_vm._s(_vm.$t("terms_label")))]
              ),
              _vm._v(" · "),
              _c(
                "a",
                {
                  attrs: {
                    href: _vm.$t("privacy_policy_uri"),
                    target: "_blank"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("privacy_policy_label")))]
              ),
              _vm._v(" · "),
              _c(
                "a",
                {
                  attrs: { href: _vm.$t("cookie_policy_uri"), target: "_blank" }
                },
                [_vm._v(_vm._s(_vm.$t("cookie_policy_label")))]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.showCookieNotification
        ? _c("div", { staticClass: "cookie-notification-container" }, [
            _c("div", { staticClass: "notification is-info" }, [
              _c("span", {
                domProps: { textContent: _vm._s(_vm.$t("cookie_notification")) }
              }),
              _vm._v(" "),
              _c("button", {
                staticClass: "delete",
                on: {
                  click: function($event) {
                    return _vm.consentCookies()
                  }
                }
              })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("recommendations-modal", {
        attrs: { active: _vm.showRecommendationsModal },
        on: {
          close: function($event) {
            return _vm.closeRecommendationsModal()
          }
        }
      }),
      _vm._v(" "),
      _c("b-loading", { attrs: { active: _vm.isLoading } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a4766e8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a4766e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/DoctorLayout.vue
// module id = 806
// module chunks = 1